/* /src/components/auth/callback.jsx */
import React, { useContext, useEffect } from "react";
import { AppContext } from "../../providers/appProvider";

export const Signin = () => {
    const { signinRedirect } = useContext(AppContext);

    useEffect(() => {
        console.log("signin");
        signinRedirect();
    }, [signinRedirect]);

    return <p>Завантаження...</p>;
};
